<script lang="ts">
  import { Tester } from 'exercises/src/uTheory.Checkpoints/tester';
  import type {
    CheckpointResults,
    CheckpointTest,
LessonCheckpointTest,
  } from 'shared/definitions/checkpoint-definitions';
  import type { ClientUserStore } from 'shared/src';
  import { createEventDispatcher, onMount } from 'svelte';
  export let test: CheckpointTest | LessonCheckpointTest;
  export let attemptId: string;
  export let clientUserStore: ClientUserStore;
  export let classSectionPassingPercent: number | undefined = undefined;

  let testDiv: HTMLDivElement;

  interface $$Events {
    testEnded: CustomEvent<CheckpointResults>;
  }

  const dispatch = createEventDispatcher<$$Events>();
  onMount(() => {
    const tester = new Tester({
      displayDiv: testDiv,
      testObject: test,
      userData: clientUserStore.userDataForInteractive,
      checkpointAttemptId: attemptId,
      classSectionPassingPercent,
    });

    tester.addGameOverCallback((results) => {
      // @ts-ignore
      dispatch('testEnded', results);
    });

    // Tear the tester down on unmount so no orphaned CountdownTimer interval
    // survives to force-submit answers to an abandoned attempt.
    return () => {
      tester.destroy();
    };
  });
</script>

<div class="unreset u-interactive" style="line-height: initial">
  <div bind:this={testDiv} />
</div>
